import isEmpty from 'lodash/isEmpty';
export default {
    props: {
        organizationBranding: {
            type: [Object, String],
            required: false,
            default: () => {
            },
        },
    },

    computed: {
        decodedOrganizationBranding() {
            if (typeof this.organizationBranding === 'string') {
                return JSON.parse(this.organizationBranding);
            }

            if (typeof this.organizationBranding === 'object') {
                return this.organizationBranding;
            }

            return {};
        },

        hasOrganizationBranding() {
            return !isEmpty(this.decodedOrganizationBranding);
        },

        hasBrandingPrimaryColor() {
            return this.hasOrganizationBranding &&
                typeof this.decodedOrganizationBranding.primaryColor === 'string'
                && /^#[0-9A-F]{6}$/i.test(this.decodedOrganizationBranding.primaryColor);
        },

        hasBrandingAccentColor() {
            return this.hasOrganizationBranding &&
                typeof this.decodedOrganizationBranding.accentColor === 'string'
                && /^#[0-9A-F]{6}$/i.test(this.decodedOrganizationBranding.accentColor);
        },

        organizationBrandingPrimaryColor() {
            return this.hasBrandingPrimaryColor ?
                this.decodedOrganizationBranding.primaryColor : '';
        },

        organizationBrandingAccentColor() {
            return this.hasBrandingAccentColor ?
                this.decodedOrganizationBranding.accentColor : '';
        },

        organizationBrandingStyle() {
            return this.hasOrganizationBranding && this.hasBrandingPrimaryColor ? {
                '--branding-primary-color': this.organizationBrandingPrimaryColor,
                '--branding-primary-color-auth-login': this.organizationBrandingPrimaryColor,
            } : {};
        },

        buttonBrandingStyle() {
            return this.hasBrandingPrimaryColor ? {
                backgroundColor: this.decodedOrganizationBranding.primaryColor,
                borderColor: this.decodedOrganizationBranding.primaryColor,
                boxShadow: 'unset',
            } : {};
        },

        textBrandingStyle() {
            return this.hasBrandingPrimaryColor ? {
                color: `${this.decodedOrganizationBranding.primaryColor} !important`,
            } : {};
        },
    },
};
